module.exports = __webpack_public_path__ + "static/media/Steppr - loyalty and gifting - vouchers and hero.2130c247.webp";